<template>
  <div class="block-area pt-12 mr-12 three-panel-condition-category-list">
    <ui-input v-model="searchBrand" class="ml-8 mr-8" :placeholder="t('Search...')" :hide-details="2" />
    <div class="list-wrap">
      <div v-if="!items.length" class="no-data">{{ t('No data available') }}</div>
      <RecycleScroller v-else key-field="name" :items="items" class="scroller" :item-size="40" v-slot="{ item }">
      <ThreePanelConditionCategoryItem
        :selected-brands="selectedBrands"
        :brand-select-all-index="brandSelectAllIndex"
        :selected-keys-index="selectedKeysIndex"
        @toggle="emit('toggle', item)"
        @select-all="emit('selectAll', item)"
        :item="item"
        :key="item.name"
        :prefix="prefix"
        :focused-item="focusedItem"
        :first-panel="firstPanel"
        :no-events="noEvents"
      />
      </RecycleScroller>
    </div>
  </div>
</template>

<script setup lang="ts">
import ThreePanelConditionCategoryItem from './three-panel-condition-category-item.vue';
import { useFlowThreePanelCategoryList } from './useFlowThreePanelCategoryList';

const props = withDefaults(
  defineProps<{
    selectedBrands?: string[];
    brandSelectAllIndex?: Record<string, boolean>;
    selectedKeysIndex?: Record<string, boolean>;
    data: Array<{ name: string }>;
    selected: Array<{ name: string }>;
    focusedItem?: { name?: string };
    firstPanel?: boolean;
    prefix?: string;
  }>(),
  {
    selectedBrands: () => [],
    brandSelectAllIndex: () => ({}),
    selectedKeysIndex: () => ({}),
    firstPanel: true,
    prefix: '',
  },
);

const focusedItem = defineModel<{ name?: string }>('focusedItem');

const emit = defineEmits<{
  toggle: [item: unknown];
  selectAll: [item: unknown];
}>();

const { t, searchBrand, items, noEvents } = useFlowThreePanelCategoryList(props);
</script>

<style lang="scss" scoped>
.list-wrap {
  height: 208px;
  box-sizing: border-box;
  padding: 4px 0;
}

.scroller {
  height: 200px;
}

.no-data {
  padding: 8px 0;
  color: var(--color-graphite);
  text-align: center;
}
.three-panel-condition-category-list {
  .v-table__overflow {
    overflow-y: scroll;
  }

  .v-datatable {
    width: 100%;
    table-layout: fixed;
    overflow-wrap: break-word;

    tbody td {
      width: 100%;
    }
  }
}
</style>
